export const dataMapper= (selectedApartmentId, tourData) => {
  const rooms = ['All Rooms']
  const brands = ['All Brands']
  const roomDesignIds = []
  const { unit } = tourData.units.find(({ unit }) => unit.id === selectedApartmentId)
  // Filter unique data
  // Rooms with designs. Sorted by weight, in case if weight is same, sorted according to alphabetical order.
  tourData.liked_assets
  .filter(liked => liked.room_design.room.unit_type.id === unit.unit_type.id)
  .sort((a, b) => (b.room_design.room.room_classification.weight === a.room_design.room.room_classification.weight
    ?(  a.room_design.room.name || a.room_design.room.classification).localeCompare(b.room_design.room.name || b.room_design.room.classification)
    : b.room_design.room.room_classification.weight - a.room_design.room.room_classification.weight))
  .forEach(({ room_design }) => {
    const r = room_design.room.name || room_design.room.classification
    const b = room_design.main_vendor.full_name
    const rId = room_design.id

    !rooms.includes(r) && rooms.push(r)
    !brands.includes(b) && brands.push(b)
    !roomDesignIds.includes(rId) && roomDesignIds.push(rId)
  })

  // Create a room designs dataset
  const roomDesigns = roomDesignIds.map(id => {
    const r = tourData.liked_assets.find(i => i.room_design.id === id)
    const a = tourData.liked_assets.filter(i => i.room_design.id === id)
    return {
      ...r.room_design,
      assets: a.map(i => ({
        ...i.asset,
        count: findCount({
          rooms: unit.unit_type.unit_type_levels.map(l=>l.rooms).flat(),
          roomId: r.room_design.room.id,
          roomDesignId: r.room_design.id,
          assetId: i.asset.id
        })
      }))
    }
  })

  return {
    brands: [brands[0], ...brands.splice(1).sort()],
    rooms,
    roomDesigns
  }
}

function findCount({
  rooms,
  roomId,
  roomDesignId,
  assetId
}) {
  return rooms.find(r => r.id === roomId)
    ?.room_designs.find(rd => rd.id === roomDesignId)
    ?.design_components.map(({ assets }) => assets).flat()
    ?.find(a => a.asset.id === assetId)?.count || 1
}
